import $ from "jquery";

const hamburger = document.querySelector('.hamburger'),
    menu = document.querySelector('.navigation'),
    header = document.querySelector('.header'),
    button = document.querySelector('.button--primary'),
    body = document.body;

// check if is child of parent elem
function isDescendant(parent, child) {
    var node = child.parentNode;
    while (node != null) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

// document.body.addEventListener('click', (e) => {
//     if( document.body.classList.contains('menu-open') ) {
//         if (!isDescendant(document.querySelector('nav'), e.target) && !isDescendant(document.querySelector('.hamburger'), e.target) ) {
//             toggleMenu();
//         }
//     }
// });

document.onkeydown = (evt) => {
    evt = evt || window.event;
    var isEscape = false;
    if ("key" in evt) {
        isEscape = (evt.key === "Escape" || evt.key === "Esc");
    } else {
        isEscape = (evt.keyCode === 27);
    }
    if (isEscape) {
        if( document.body.classList.contains('menu-open') ){
            toggleMenu()
        }
    }
};

//Toggle hamburger menu
function toggleMenu() {
    hamburger.classList.toggle('hamburger--open');
    menu.classList.toggle('navigation--open');
    header.classList.toggle('menu-open');
    body.classList.toggle('menu-open');
    button.classList.toggle('menu-open');
}

if (hamburger) {
    hamburger.addEventListener('click', toggleMenu);
}


//Add arrow if item has a submenu MI-website
document.querySelectorAll('.navigation > ul > li').forEach(function (element) {
    if (element.querySelector('.submenu')) {
        element.classList.add('has_submenu');

        element.addEventListener('click', function (e) {

            if( e.srcElement.nodeName === 'LI' ) {
                e.preventDefault();
                element.classList.toggle('sub-open');
                document.querySelector('.submenu').classList.toggle('sub-open');
                hamburger.classList.toggle('hamburger--sub-open');
            }
        });
    }
});


//Fixed sticky header when scrolling
$(document).ready(function(){
    $(window).scroll(function(){
        // console.log('Scroll event triggered'); // Add this line for debugging
        if ($(window).scrollTop() >= 39) {
            $('.header').addClass('fixed-header');
        } else {
            $('.header').removeClass('fixed-header');
        }
    });
});

// FK: submenu on mobile
document.querySelectorAll('ul.navigation > li').forEach(function (element) {
    if (element.querySelector('.submenu')) {
        element.classList.add('has_submenu');
    }
});

// FK add hover class to top menu
function menuGlider() {
    const listItems = document.querySelectorAll('.leftnav ul li:not(.glider)');
    const glider = document.querySelector('.leftnav .glider');
    const currentUrl = window.location.href;

    let activePosition = 0,
        activeWidth = 0,
        activeContent = '';

    listItems.forEach(item => {
        const link = item.querySelector('a');

        if (link.href === currentUrl || item.classList.contains('active')) {
            const activeItem = item.classList.contains('active') ? item : null;

            if (activeItem) {
                activePosition = activeItem.offsetLeft;
                activeWidth = activeItem.offsetWidth;
                activeContent = activeItem.querySelector('a').textContent;

                // Position the glider correctly
                glider.style.transition = 'none';
                glider.style.transform = `translateX(${activePosition}px)`;
                document.querySelector(':root').style.setProperty('--liWidth', `${activeWidth}px`);
                glider.textContent = activeContent;

                setTimeout(() => {
                    glider.style.transition = 'transform 0.3s ease';
                }, 10);
            }
        }

        // Hover effects
        link.addEventListener('mouseenter', () => {
            const liWidth = item.offsetWidth;
            const liPosition = item.offsetLeft;

            glider.style.transform = `translateX(${liPosition}px)`;
            document.querySelector(':root').style.setProperty('--liWidth', `${liWidth}px`);
            glider.textContent = link.textContent;
        });

        link.addEventListener('mouseleave', () => {
            glider.style.transform = `translateX(${activePosition}px)`;
            document.querySelector(':root').style.setProperty('--liWidth', `${activeWidth}px`);
            glider.textContent = activeContent;
        });
    });

}
$(document).ready(function() {
    menuGlider();
});

$(document).scroll(function() {
    menuGlider();
});

$(window).resize(function() {
    menuGlider();
});

